var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['button-link', { 'is-loading': _vm.loading, 'is-disabled': _vm.disabled }],attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"button-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }